export default __webpack_public_path__ + "static/media/validacion-exitosa.cf5ca69a.svg";